<template>
  <div>
    <Menu />
    <div id="teste-pezinho" class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Teste do pezinho"
            description="Gestantes a parir por mês."
            url="/saude-crianca"
          />
        </div>
        <div class="col-md-12">
          <selects
            :callbackOnChangeEquipe="onChangeEquipe"
            :callbackOnChangeProfissional="onChangeProfissional"
            :activeSelectMicroArea="true"
            :callbackOnChangeMicroArea="onChangeMicroArea"
          ></selects>
        </div>
        <div class="col-md-12">
          <b-tabs fill class="esus-feedback-tabs" v-model="tabsActive">
            <b-tab title="Lista" active @click="buscarDadosDaLista()">
              <template v-slot:title>
                <i class="icofont-list"></i> Lista
              </template>
              <div class="row">
                <div class="full-table">
                  <div class="col-md-12">
                    <div class="info-table">
                      <div class="select-situacao info-table-item">
                        <vue-select
                          :options="mesDPPOptions"
                          label="label"
                          placeholder="Mês da DPP"
                          v-model="mesDPP"
                          @input="handleMesDPP()"
                          :clearable="true"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.label }}
                          </template>
                          <div slot="no-options">
                            Não há opções correspondentes
                          </div>
                        </vue-select>
                      </div>
                      <div class="info-table-item">
                        <download-files
                          :callback-pdf="generatePdf"
                          :data="displayedCadastros"
                          :fields="dataFields"
                          :name="`${titlePdf('teste-pezinho', nomeEquipe)}`"
                        >
                        </download-files>
                      </div>
                    </div>
                    <tabela-cadastros
                      ref="table"
                      :cadastros="displayedCadastros"
                      :data_secretaria_de_saude="data_secretaria_de_saude"
                      :loading="loadingLista"
                      texto_esus_pec="Atendimentos registrados até"
                      :data_esus_pec="data_secretaria_de_saude"
                      @filterSearch="filterSearch($event)"
                    ></tabela-cadastros>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import Loader from '@/components/Loader'
import SectionTitle from '@/components/SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions'
import TabelaCadastros from './TabelaCadastros.vue'
import utils from '@/mixins/utils.js'
import TitleTag from '@/components/TitleTag.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { dataFields } from './utils.js'
import Selects from '@/components/utils/Selects.vue'

export default {
  name: 'TestePezinho',
  metaInfo: {
    title: 'Teste do pezinho',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    PulseLoader,
    Loader,
    SectionTitle,
    TabelaCadastros,
    TitleTag,
    DownloadFiles,
    Selects,
  },
  mixins: [utils],
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipe: '',
      profissionais: [],
      profissional: '',
      dados: [],
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      data_ministerio_da_saude: null,
      populacaoIbge: 0,
      total_de_registros_da_tabela: 0,
      data_secretaria_de_saude: '',
      loadingResultado: false,
      loadingLista: false,
      loadingGrafico: false,
      size: '40px',
      color: '#0D98BB',
      por_municipio_gestantes_estimadas: 0,
      por_municipio_gestantes_informadas: 0,
      por_municipio_pre_natal: 0,
      por_municipio_resultado: 0,
      por_equipe_gestantes_estimadas: 0,
      por_equipe_gestantes_informadas: 0,
      por_equipe_pre_natal: 0,
      por_equipe_resultado: 0,
      resultado_no_municipio: '',
      resultado_na_equipe: '',
      secretaria_municipal_de_saude_no_acs_numerador: 0,
      secretaria_municipal_de_saude_no_acs_denominador: 0,
      secretaria_municipal_de_saude_no_acs_resultado: 0,
      secretaria_municipal_de_saude_no_municipio_meta: 0,
      secretaria_municipal_de_saude_na_equipe_meta: 0,
      secretaria_municipal_de_saude_no_acs_meta: 0,
      tabsActive: 0,
      nomeEquipe: '',
      nomeProfissional: '',
      cadastrosPdf: [],
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      micro_areas: [],
      micro_area: '',
      select_microarea: '',
      select_profissional: '',
      mesDPPOptions: [],
      mesDPP: '',
      cadastrosOriginais: [],
      setRed: false,
      dataFields: { ...dataFields },
      filterSearchTable: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    handleMesDPP() {
      if (this.mesDPP.value === 'TODOS') {
        this.cadastros = this.dados
      } else {
        this.cadastros = this.dados.filter(
          (item) => item.mes_dpp == this.mesDPP.value
        )
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.loadingLista = true
        this.situacao = ''
        this.tabsActive = 0
        this.select_microarea = null
        this.select_profissional = null
        this.profissionais = []
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = event
        this.nomeEquipe = event.no_equipe
        this.select_microarea = null
        this.mesDPP = null
        this.nomeProfissional = ''
        try {
          const response2 = await this.$api.get(
            '/app/teste-pezinho/' +
              this.cod_ibge +
              '/equipe/' +
              this.equipe.nu_ine
          )
          this.dados = response2.data
          this.cadastros = response2.data
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingLista = false
        }
      } else {
        this.nomeEquipe = ''
        this.cadastros = []
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == null) {
        this.cadastros = []
        return
      }
      this.profissional = event
      this.nomeProfissional = event?.no_profissional
      this.mesDPP = null
      this.select_microarea = null
      this.tabsActive = 0
      this.page = 1
      this.buscarDadosDaLista()
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == null) {
        this.cadastros = []
        return
      }
      try {
        this.mesDPP = null
        this.loadingLista = true
        this.nomeProfissional = ''
        this.profissional = null
        this.select_profissional = null
        this.micro_area = event?.micro_area
        if (this.micro_area == undefined) {
          this.tabsActive = 0
        }
        if (this.micro_area !== undefined) {
          const response = await this.$api.get(
            '/app/teste-pezinho/' +
              this.cod_ibge +
              '/micro-area/' +
              this.equipe.nu_ine +
              '/' +
              this.micro_area
          )
          if (response) {
            this.dados = response.data
            this.cadastros = response.data
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingLista = false
      }
    },

    // busca os dados de acordo com os valores do select
    async buscarDadosDaLista() {
      if (this.profissional !== '' && this.profissional !== null) {
        this.loadingLista = true
        try {
          let response = await this.$api.get(
            '/app/teste-pezinho/' +
              this.cod_ibge +
              '/acs/' +
              this.profissional.nu_cpf
          )
          if (response) {
            this.dados = response.data
            this.cadastros = response.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingLista = false
        }
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.profissional,
        this.nomeProfissional,
        this.data_secretaria_de_saude
      )
    },

    async buscarDadosIniciais() {
      try {
        const response = await this.$api.get(
          '/app/teste-pezinho/' + this.cod_ibge
        )
        if (response) {
          this.dados = response.data
          this.cadastros = response.data

          response.data.forEach((item) => {
            this.mesDPPOptions.push({
              label: item.mes_dpp,
              value: item.mes_dpp,
            })
          })

          this.mesDPPOptions.push({ label: 'TODOS', value: 'TODOS' })

          // removendo valores duplicados
          this.mesDPPOptions = this.mesDPPOptions
            .map((e) => JSON.stringify(e))
            .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
            .map((e) => JSON.parse(e))

          // ordenando
          this.mesDPPOptions = this.mesDPPOptions.sort(function (a, b) {
            let dateA = new Date(a.value.split('/')[1], a.value.split('/')[0])
            let dateB = new Date(b.value.split('/')[1], b.value.split('/')[0])
            if (dateA > dateB) return 1
            if (dateA < dateB) return -1
            return 0
          })
        }
      } catch (error) {
        console.log(error)
      }
    },

    validateToken() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.validateToken()
  },
}
</script>

<style scoped>
.tabela {
  margin: 0px auto;
  margin-bottom: 16px;
}

th,
td {
  padding: 5px 10px;
  text-align: center;
  border: 1px solid #e8e8e8;
}
td:first-child {
  border-top: unset;
  border-right: unset;
}
th:first-child {
  border-top: unset;
  border-left: unset;
}
.barrinha {
  width: 35px;
  height: 5px;
  display: block;
  border-radius: 10px;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}
.titulo_td {
  display: flex;
  align-items: center;
  gap: 5px;
}
.sem-borda {
}
thead {
  border-top: unset;
  border-left: unset;
}
</style>
<style>
.select-situacao {
  margin: 10px;
  min-width: 210px;
}
@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}
@media screen and (max-width: 992px) {
  .info-table {
    flex-direction: column;
  }
}
</style>
<style>
#teste-pezinho .select-situacao .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#teste-pezinho .select-situacao .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#teste-pezinho .select-situacao .v-select {
  width: 296px;
}
#teste-pezinho .select-situacao .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
